export var CareTeamMemberType;
(function (CareTeamMemberType) {
    CareTeamMemberType["PHYSICIAN_AND_NURSE"] = "PHYSICIAN_AND_NURSE";
    CareTeamMemberType["ALLIED_CARE_PROFESSIONAL"] = "ALLIED_CARE_PROFESSIONAL";
})(CareTeamMemberType || (CareTeamMemberType = {}));
